import NewUserPage from "./NewUserPage"
export default NewUserPage
